export type BusinessGoal =
  | "leads"
  | "sales"
  | "awareness"
  | "appointments"
  | "website_traffic"
  | "customer_retention";

export type CampaignDuration =
  | "two_weeks"
  | "thirty_days"
  | "ninety_days"
  | "six_months"
  | "twelve_months";

export type CampaignIntensity = "light" | "standard" | "aggressive" | "dominate";

export type CommanderChannel =
  | "instagram"
  | "facebook"
  | "linkedin"
  | "tiktok"
  | "x"
  | "email"
  | "blog"
  | "google_business_profile"
  | "ads_meta"
  | "ads_google"
  | "sms";

export interface CommanderAnswers {
  promotion: string;
  business_goal: BusinessGoal;
  target_audience: string;
  duration: CampaignDuration;
  intensity: CampaignIntensity;
  channels: CommanderChannel[];
}

export interface CommanderResponse {
  blueprint: {
    id: string;
    status: string;
    workspace_id: string;
  };
  promise: string;
  next_step_url: string;
}

/** Warm acknowledgment palette — per Product Principles Article II. */
export const ACKNOWLEDGMENTS: string[] = [
  "Excellent.",
  "Beautiful.",
  "Good — that helps.",
  "Got it.",
  "Perfect.",
  "That shapes the strategy.",
];

/** Channel prefill matrix — driven client-side, no LLM call. */
export const GOAL_CHANNEL_HINTS: Record<BusinessGoal, CommanderChannel[]> = {
  leads: ["instagram", "facebook", "email", "google_business_profile"],
  sales: ["instagram", "facebook", "email", "ads_meta"],
  awareness: ["instagram", "facebook", "tiktok", "blog"],
  appointments: ["google_business_profile", "email", "instagram"],
  website_traffic: ["blog", "email", "linkedin"],
  customer_retention: ["email", "instagram"],
};
